import template from './in-flat-rent.jade';
import inFlatRentAdditional from '../../../enums/in-flat-rent-additional';

export default angular.module('cian.addForm.inFlatRent', []).directive('cianAfAboutObjectInFlatRent', () => ({
  scope: {},
  bindToController: {
    ad: '=',
    form: '=',
  },
  controller: [
    function () {
      this.checkboxes = inFlatRentAdditional;
    },
  ],
  controllerAs: 'inFlatRent',
  template,
})).name;
